<template>
  <div>
    <div class="flex items-center my-4">
      <IndicatorsIcon class="text-primary-light w-10 mr-1" />
      <h1 class="text-black text-xl lg:text-2xl">Most Common Non-Conformities</h1>

      <v-tooltip right>
        <template v-slot:activator="{on, attrs}">
          <fa-icon
              v-bind="attrs"
              v-on="on"
              icon="question-circle"
              class="ml-2 mt-1 text-grey-2"
          ></fa-icon>
        </template>
        <span>Most common non-conformities</span>
      </v-tooltip>
    </div>

    <div>
      <div v-if="chartDataBar.labels.length" class="w-1/2 max-h-50 mx-auto relative overflow-auto">
        <div class="my-8 text-center">
          <Bar :chart-data="chartDataBar" :options="chartOptions" :type="'horizontalBar'" :height="chartSize" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import IndicatorsIcon from '@/assets/icons/icons_indicators.svg'
import Loader from "@/assets/loader.svg";
import { Bar } from 'vue-chartjs/legacy'
import { Chart, registerables } from 'chart.js'
Chart.register(...registerables)

export default {
  name: 'MostNotMets',
      components: { Bar, Loader, IndicatorsIcon },
  props: {
    stats: {
      type: Object,
    default: () => ({})
    }
  },
  mounted() {
    console.log('Mounted: MostNotMets stats:', this.stats)
    this.updateChartData()
  },
  computed: {
    commonNonConformities() {
      return this.stats.commonNonConformities || []
    }
  },
  watch: {
    commonNonConformities: {
      handler() {
        console.log('Watch: commonNonConformities changed', this.commonNonConformities)
        this.updateChartData()
      },
      immediate: true
    }
  },
  methods: {
    interpolateColor(ratio) {
      // Color stops
      const end = [215, 118, 118];
      const middle = [246, 179, 131];
      const start = [246, 227, 131];

      let color;
      if (ratio <= 0.5) {
        // Interpolate start to middle
        const t = ratio / 0.5;
        color = start.map((c, i) => Math.round(c + (middle[i] - c) * t));
      } else {
        // Interpolate middle to end
        const t = (ratio - 0.5) / 0.5;
        color = middle.map((c, i) => Math.round(c + (end[i] - c) * t));
      }
      return `rgb(${color[0]},${color[1]},${color[2]})`;
    },
    updateChartData() {
      const data = this.commonNonConformities;
      this.chartDataBar.labels = data.map(item => item.indicator);
      this.chartDataBar.datasets[0].data = data.map(item => item.uniquePractices);

      // Sort values descending for color grading
      const sorted = [...data].sort((a, b) => b.uniquePractices - a.uniquePractices);
      const max = sorted[0]?.uniquePractices || 1;
      const min = sorted[sorted.length - 1]?.uniquePractices || 0;

      // Gradient color mapping
      this.chartDataBar.datasets[0].backgroundColor = data.map(item => {
        const ratio = (item.uniquePractices - min) / (max - min || 1);
        return this.interpolateColor(ratio);
      });
    }
  },
  data() {
    return {
      chartSize: 280,
      chartDataBar: {
        labels: [],
        datasets: [
          {
            label: 'How many practices had a non-conformity for each indicator',
            backgroundColor: '#42A5F5',
            data: [],
            barThickness: 20
          }
        ]
      },
      chartOptions: {
        // indexAxis: 'y', // Transpose axes
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          y: {
            title: { display: true, text: 'Indicator' },
            grid: { display: false }
          },
          x: {
            title: { display: true, text: 'Unique Practices' },
            beginAtZero: true,
            min: 0
          }
        },
        plugins: {
          legend: { display: false },
          title: {
            display: false
          },
          tooltip: {
            mode: 'y',
            displayColors: false,
            intersect: false,
            callbacks: {
              title: (tooltipItems) => 'Unique Practices: ' + tooltipItems[0].parsed.x,
              label: () => ''
            }
          }
        }
      }
    }
  }
}
</script>